module.exports = __webpack_public_path__ + "static/media/MealSettingsGrey.9d1a06d5.svg";